module.exports = __webpack_public_path__ + "static/media/linkCard_charging_hover.a3f58477.svg";